import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../Shared/Permission/Permission";
import { Navigator } from "../../../Shared/Wizards/Entities/Navigator";
import { UnsplashBackgroundSelect } from "./UnsplashBackgroundSelect";
import { Urls } from "../../Urls";
import { UIThemeAction } from "./Action/UIThemeAction";
import { FirmLogoDispatcher, FirmLogoStore, UserStore } from "../../Stroes/Variable";
import { Action } from "../../Actions/Action";
import { GetUserUIThemeConfiguration } from "../../../../Wrap/Models/Models/Session/GetUserUIThemeConfiguration";
import { User } from "../../../../Wrap/Models/Models/User/User";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { PortfolioDashboardAction } from "../Clients/PortfolioDashboard/Action/PortfolioDashboardAction";

interface ISettingsProps {}

interface ISettingsState {
    currentTheme: string;
    unsplashDetails: GetUserUIThemeConfiguration;
    userInfo: User;
}

export class Settings extends BaseComponent<ISettingsProps, ISettingsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentTheme: "light",
            unsplashDetails: null,
            userInfo: UserStore.getUserInfo(),
        };
    }

    componentDidMount() {
        UIThemeAction.getUITheme((response: GetUserUIThemeConfiguration) => {
            this.setState({ unsplashDetails: response, currentTheme: response.Style });
        });
    }

    setupTheme = (isLightMode: boolean) => {
        UIThemeAction.setUITheme(isLightMode, (_style) => {
            const href = `/Configs/SLREBRANDPOC/leapfrog-css/${_style}.css`;
            document.getElementById("stylesheetLink").setAttribute("href", href);
            this.setState({ currentTheme: _style });
            FirmLogoDispatcher.dispatch({
                payload: FirmLogoStore.getFirmLogoInfo(),
                actionType: ActionType.Success,
            });
        });
    };

    clearAccountSettingsAndLogout = () => {
        PortfolioDashboardAction.deleteSettings((callBack) => {
            window.location.assign(`/home.aspx?logout=1`);
        });
    };

    render() {
        const { currentTheme, unsplashDetails, userInfo } = this.state;
        return (
            <>
                <div className="ad d1">
                    <h1 className="page-heading">Settings</h1>
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <h2 className="h4 mb-8 mt-20">UI theme</h2>
                            <RadiosEditor
                                cssWrapper="radio-group rg-inline legend-sr-only pb-50"
                                options={[true, false]}
                                selected={currentTheme != "dark-blue"}
                                getText={(o) => {
                                    return o ? "Light mode" : "Dark mode";
                                }}
                                onChange={(v) => {
                                    this.setupTheme(v);
                                }}
                            />
                            {/* <Permission userClaim={UserClaim.AdviserPortalChangeBackgroundImageReadWrite}>
                                {unsplashDetails && <UnsplashBackgroundSelect unsplashDetails={unsplashDetails} />}
                            </Permission> */}
                        </div>
                        <div className="col-12 col-lg-3">
                            <div className="panel">
                                <h2 className="mb-20">{userInfo?.ClientName}</h2>
                                <div>
                                    <Permission userClaim={UserClaim.AdviserPortalAddFirmLogoCanView}>
                                        <button
                                            className="button inline-block mb-8 mr-10"
                                            onClick={() => Navigator.navigateTo(Urls.get().AddLogo)}
                                        >
                                            Add firm logo
                                        </button>
                                    </Permission>
                                    <Permission userClaim={UserClaim.AdviserPortalDluChangePasswordCanView}>
                                        <a
                                            href="javascript:void(0);"
                                            className="button inline-block mb-8 mr-10"
                                            onClick={() => {
                                                localStorage.clear();
                                                window.location.assign(
                                                    `/admin/logindetails/logindetails-changepassword.aspx`
                                                );
                                            }}
                                        >
                                            Change password
                                        </a>
                                    </Permission>
                                    <a
                                        href="javascript:void(0);"
                                        className="button inline-block mb-8"
                                        onClick={() => this.clearAccountSettingsAndLogout()}
                                    >
                                        Log out
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
